import { render, staticRenderFns } from "./PauseCustomerOrderModal.vue?vue&type=template&id=cb02d3a6&scoped=true&"
import script from "./PauseCustomerOrderModal.vue?vue&type=script&lang=js&"
export * from "./PauseCustomerOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb02d3a6",
  null
  
)

export default component.exports